import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/Info/DisplayError';
import Loading from '../../../../components/Info/Loading';
import { AuthenticationError } from '../../../GradeEntry/Loaders/CreateEvaluationGradeEntryBaseLoader';
import { getFormData } from '../api';
import { StudentFileFormDataResponse } from '../types';

export interface StudentFileFilterLoaderProps {
  onError?: (code: string, onUnknown?: (() => void) | undefined) => void;
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  StudentFileFormDataResponse,
  AuthenticationError | AxiosResultDefaultError
>();

export const SustainerLoaderConsumer = FetchConsumer;

export const useStudentFileFilterLoader = useFetch;

export default function FormLoader({
  onError,
  children,
}: StudentFileFilterLoaderProps) {
  const request = useCallback(async () => {
    return getFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            onError && onError(error.code);
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
